import { memo, useContext } from "react";
import { useSelector } from "react-redux";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { FormFieldsContext } from "layouts/Flow Designer/context";
import { form } from "../schemas/form";
import { ThemedTrashIcon } from "assets/CXFIcons/Triggers";

const OptionLabel = ({ label, name, isPayloadContent, allowEditWorkflow }) => {
  const formRef = useContext(FormFieldsContext);
  const { additionalOptions } = form.formField;
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  const handleDeleteOption = (e) => {
    e.stopPropagation();
    formRef?.setFieldValue(
      additionalOptions.name,
      [...(formRef?.values?.additionalOptions ?? [])].filter((option) => option !== name)
    );

    switch (name) {
      case "requestHeaders":
      case "responseHeaders":
        formRef?.setFieldValue(name, []);
        break;
      case "payloadContentType":
        formRef?.setFieldValue(name, "");
        formRef?.setFieldValue("formData", []);
        formRef?.setFieldValue("payload", "");
        break;
      default:
        formRef?.setFieldValue(name, "");
    }
  };

  return (
    <SoftBox sx={{ display: "flex", alignItems: "center" }}>
      <SoftTypography
        variant="caption"
        fontWeight="regular"
        color="secondary"
        sx={{ marginLeft: "4px" }}
      >
        {label}
      </SoftTypography>

      {!isPayloadContent && !isFlowActive && allowEditWorkflow && (
        <IconButton size="small" onClick={handleDeleteOption}>
          <Tooltip title="Delete Option" placement="top">
            <ThemedTrashIcon width="18px" height="18px" className="delete-trigger-option-icon" />
          </Tooltip>
        </IconButton>
      )}
    </SoftBox>
  );
};

export default memo(OptionLabel);
